import { render, staticRenderFns } from "./EditDecision.vue?vue&type=template&id=99fe0738&scoped=true"
import script from "./EditDecision.vue?vue&type=script&lang=js"
export * from "./EditDecision.vue?vue&type=script&lang=js"
import style0 from "./EditDecision.vue?vue&type=style&index=0&id=99fe0738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fe0738",
  null
  
)

export default component.exports